<template>
  <slot v-if="$slots.default" v-bind="{ result }" />
  <span
    v-else
    data-cy="transformed-value"
    class="transformed-value"
    :class="cssClasses"
    :data-private="columnConfig?.mask ? '' : null"
    :title="result.tooltip"
    v-tooltip="{ content: result.tooltip, theme: 'lookdeep-global' }"
  >
    {{ displayLabel }}
  </span>
</template>

<script>
import TransformerService, {getColumnByTarget} from '@/lib/transformers'

export default {
  name: 'TransformedValue',

  props: {
    target: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean, Date],
      default: null
    },
    fallback: {
      type: String,
      default: null
    },
    rules: {
      type: Object,
      default: null
    }
  },

  computed: {
    columnConfig() {
      return getColumnByTarget(this.target)
    },

    formattedValue() {
      let val = this.value
      if (this.columnConfig?.dataType === 'datetime' && val) {
        val = this.$helpers.formatDate(val, this.columnConfig.dateFormat || 'lll', this.columnConfig.withoutTimezone || false)
      }
      if (this.columnConfig?.mask && val) {
        val = this.$helpers.mask(this.columnConfig.mask, val)
      }
      return val
    },

    result() {
      return TransformerService.apply(this.target, this.formattedValue, this.rules, { rawValue: this.value })
    },

    displayLabel() {
      if (this.result.label !== null && this.result.label !== undefined) {
        return this.result.label
      }
      if (this.fallback && (this.value === null || this.value === undefined || this.value === '')) {
        return this.fallback
      }
      return this.formattedValue
    },

    cssClasses() {
      return {
        [`background-color background-color--${this.result.backgroundColor}`]: this.result.backgroundColor,
        [`text-color text-color--${this.result.textColor}`]: this.result.textColor
      }
    }
  },

  watch: {
    result: {
      immediate: true,
      handler(val) {
        this.$emit('resolved', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.transformed-value {
  display: inline-block;
  border-radius: 4px;
  &.background-color {
    padding: 2px 8px;
  }
}
</style>
